import React from 'react';

const ChefHatGold = props => {
  return (
    <svg
      width="24"
      height="32"
      viewBox="0 0 24 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 10.782V7C6.00475 5.41016 6.63841 3.8868 7.7626 2.7626C8.8868 1.63841 10.4102 1.00475 12 1V1C13.5898 1.00475 15.1132 1.63841 16.2374 2.7626C17.3616 3.8868 17.9953 5.41016 18 7V10.783"
        stroke="#FABD18"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12 31C18.0751 31 23 26.0751 23 20C23 13.9249 18.0751 9 12 9C5.92487 9 1 13.9249 1 20C1 26.0751 5.92487 31 12 31Z"
        stroke="#FABD18"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12 22V25"
        stroke="#FABD18"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12 22C13.6569 22 15 20.6569 15 19C15 17.3431 13.6569 16 12 16C10.3431 16 9 17.3431 9 19C9 20.6569 10.3431 22 12 22Z"
        stroke="#FABD18"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default ChefHatGold;



// WEBPACK FOOTER //
// ./src/svg/LockGold.js